<template>
  <button :class="buttonClasses" :disabled="disabled">{{ label }}</button>
</template>

<script lang="ts" setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  label: String,
  disabled: Boolean,
  fullWidth: {
    type: Boolean,
    default: true,
  },
});

const buttonClasses = computed(() => ({
  button: true,
  ["full-width"]: props.fullWidth,
}));
</script>

<style scoped>
.button {
  border-radius: 4px;
  background-color: var(--md-sys-color-secondary-fixed);
  border: none;
  padding: 6px 12px;

  &:hover:not(:disabled) {
    background-color: var(--md-sys-color-primary-fixed-dim);
  }

  &:active:not(:disabled) {
    background-color: var(--md-sys-color-secondary-fixed-dim);
  }

  &:disabled {
    background-color: var(--md-sys-color-error-container);
  }
}

.full-width {
  width: 100%;
}
</style>
